if (document.readyState !== 'loading') {
    checkVariants();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        checkVariants();
    });
}

function checkVariants() {
 const optionSelects = document.querySelectorAll('.options-selection__input-select');
  if(optionSelects.length > 0){
    const variantSelect = document.querySelector('.variant-selection__variants');
    const productData = document.getElementById('product-data');
    const productHandle = productData ? productData.getAttribute('data-product-handle') : null;
    
    if (variantSelect && productHandle) {
      let selectedVariant = null;
      if(variantSelect.value && variantSelect.value != "not-selected" && typeof variantSelect.value != "undefined"){
        const selectedVariantId = variantSelect.value;
        document.querySelectorAll(`.variant-specifications`).forEach(el => el.style.display = 'none');
        document.querySelectorAll(`.variant-resource`).forEach(el => el.style.display = 'none');
        document.querySelector(`.variant-specifications[data-variant-option-value-sku="${selectedVariantId}"]`).style.display = 'block';
        document.querySelector(`.variant-resource[data-variant-option-value-sku="${selectedVariantId}"]`).style.display = 'block';
      }
      optionSelects.forEach((currOption,index) => {
        currOption.addEventListener('change', function () {
          selectedVariant = null;
          let optionList = [];
          optionSelects.forEach(option => {
            optionList.push(option.value)
          });
          variantSelect.querySelectorAll('option').forEach(variant => {
            if (optionList.every(function(v) {
              let variantOptions = variant.textContent.split(" - $")[0].trim().replaceAll(/(\r\n|\n|\r)/gm, "");
              let variantOptionsArray = [];
              if(variantOptions.split(" / ") != null && typeof variantOptions.split(" / ") != "undefined"){
                variantOptionsArray = variantOptions.split(" / ");
              }

              if(variantOptionsArray[index] && typeof variantOptionsArray[index] != "undefined"){
                return variantOptionsArray.indexOf(v) >= 0;
              }else{
                return false;
              }
              
            })) {
              selectedVariant = variant;
            }
          });
          
          if(selectedVariant){
            variantSelect.value = selectedVariant.value
            var event = new Event('change');
            variantSelect.dispatchEvent(event);
            const selectedVariantId = selectedVariant.value;
            document.querySelectorAll(`.variant-specifications`).forEach(el => el.style.display = 'none');
            document.querySelectorAll(`.variant-resource`).forEach(el => el.style.display = 'none');
            document.querySelector(`.variant-specifications[data-variant-option-value-sku="${selectedVariantId}"]`).style.display = 'block';
            document.querySelector(`.variant-resource[data-variant-option-value-sku="${selectedVariantId}"]`).style.display = 'block';
          }
        });
      });
    }
  } 
}